import cn from 'classnames';
import React from 'react';
import { useQuestionTitleContext, useRegisterTitleRef } from '../../containers/root/QuestionTitleContext';
import Markdown from '../Markdown';
import styles from './QuestionTitle.module.css';

interface QuestionTitleProps {
  className?: string;
  children?: string;
  required?: boolean;
  questionId: string;
  alignSurvey: 'left' | 'center';
}

export const QuestionTitle = ({ className, children = '', required, questionId, alignSurvey }: QuestionTitleProps) => {
  const isCode = children.endsWith('```');

  const { registerTitleRef } = useRegisterTitleRef(questionId);
  const { isGroupPage } = useQuestionTitleContext();

  const markdownText = (
    <Markdown>{`${children}${
      required && !isCode && isGroupPage ? `<span class=${styles.requiredSymbol}>*</span>` : ''
    }`}</Markdown>
  );

  const alignByCenter = alignSurvey === 'center';

  if (!children) return;

  return (
    <h1 className={cn(className, styles.title, { [c(styles.titleCenter)]: alignByCenter })} ref={registerTitleRef}>
      {markdownText}
      {required && isCode && isGroupPage && <span className={styles.requiredSymbol}>*</span>}
    </h1>
  );
};
